const AUTH_REDIRECT_KEY = "auth_redirect";

function getSessionStorage(): Storage | null {
  try {
    return globalThis.sessionStorage;
  } catch {
    return null;
  }
}

function isSafeRedirect(path: unknown): path is string {
  return (
    typeof path === "string" &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    !path.startsWith("/auth/")
  );
}

export function saveAuthRedirect(path: string): void {
  if (isSafeRedirect(path)) {
    getSessionStorage()?.setItem(AUTH_REDIRECT_KEY, path);
  }
}

export function consumeAuthRedirect(): string | null {
  const storage = getSessionStorage();
  const path = storage?.getItem(AUTH_REDIRECT_KEY) ?? null;
  storage?.removeItem(AUTH_REDIRECT_KEY);
  return isSafeRedirect(path) ? path : null;
}
